import React from "react";

type PictureProps = {
  color?: string;
};
const Picture: React.FC<PictureProps> = ({ color = "#ffffff" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 7.25C11.75 7.67 11.98 8.05 12.355 8.24L13.86 9.005C14.35 9.255 14.745 9.65 14.995 10.14L15.76 11.645C15.95 12.02 16.33 12.25 16.75 12.25C17.17 12.25 17.55 12.02 17.74 11.645L18.505 10.14C18.755 9.65 19.15 9.255 19.64 9.005L21.145 8.24C21.52 8.05 21.75 7.67 21.75 7.25C21.75 6.83 21.52 6.45 21.145 6.26L19.64 5.495C19.15 5.245 18.755 4.85 18.505 4.36L17.74 2.855C17.55 2.48 17.17 2.25 16.75 2.25C16.33 2.25 15.95 2.48 15.76 2.855L14.995 4.36C14.745 4.85 14.35 5.245 13.86 5.495L12.355 6.26C11.98 6.45 11.75 6.83 11.75 7.25ZM14.54 6.83C15.315 6.435 15.935 5.815 16.33 5.04L16.75 4.215L17.17 5.04C17.565 5.815 18.185 6.435 18.96 6.83L19.785 7.25L18.96 7.67C18.185 8.065 17.565 8.685 17.17 9.46L16.75 10.285L16.33 9.46C15.935 8.685 15.315 8.065 14.54 7.67L13.715 7.25L14.54 6.83Z"
        fill={color}
      />
      <path
        d="M8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17158 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17158 9.5 8 9.5Z"
        fill={color}
      />
      <path
        d="M21 10.25C20.585 10.25 20.25 10.585 20.25 11V16C20.25 16.06 20.245 16.12 20.24 16.18L18.045 14.295C17.005 13.4 15.495 13.4 14.455 14.295L13.295 15.295L9.82 12.31C8.78 11.415 7.27 11.415 6.23 12.31L3.755 14.44V8.005C3.755 5.66 5.66 3.755 8.005 3.755H13.005C13.42 3.755 13.755 3.42 13.755 3.005C13.755 2.59 13.42 2.255 13.005 2.255H8.005C4.835 2.255 2.255 4.835 2.255 8.005V16.005C2.255 19.175 4.835 21.755 8.005 21.755H16.005C19.175 21.755 21.755 19.175 21.755 16.005V11.005C21.755 10.59 21.42 10.255 21.005 10.255L21 10.25ZM3.77 16.395L7.205 13.445C7.68 13.035 8.37001 13.04 8.84 13.445L12.14 16.28L7.55 20.225C5.545 20.015 3.955 18.405 3.77 16.395ZM16 20.25H9.825L15.435 15.43C15.91 15.02 16.6 15.02 17.07 15.43L19.84 17.81C19.16 19.25 17.695 20.25 16 20.25Z"
        fill={color}
      />
    </svg>
  );
};

export default Picture;
